<mat-card class="tw-bg-gray-300 tw-text-black tw-m-2">
    @if (aiBuffering) {
        &nbsp;&nbsp;Document bot is writing a response
    }
</mat-card>
